"use client";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import Button from "../commons/Button";
import { Link } from "react-router-dom";

export default function DialogDelete({
    open,
    onClose,
    type = "loading", // 'loading', 'failed', or 'confirmation'
    title, // Dynamic title from outside
    message, // Dynamic message from outside
    iconSrc = "",
    buttonText = "Close",
    buttonLink = "/",
    onButtonClick,
}) {
    const getIcon = () => {
        switch (type) {
            case "loading":
                return (
                    <img
                        src="/assets/icons/icon-loading.svg"
                        className="animate-spin"
                        alt="Loading"
                    />
                );
            case "failed":
                return <img src="/assets/icons/icon-warning-circle.svg" alt="Failed" />;
            default:
                return iconSrc ? <img src={iconSrc} alt="Icon" className="w-[60px] h-[60px]" /> : null;
        }
    };

    return (
        <Dialog open={open} onClose={onClose} className="relative z-[10002]">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto ">
                <div className="flex min-h-full items-center justify-center p-4 sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden bg-[#181818] rounded-[14px] backdrop-blur-sm shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in w-full max-w-[400px]"
                    >
                        <div className="w-full relative">
                            <button
                                onClick={onClose}
                                className="absolute top-2 right-2 cursor-pointer z-[1]"
                            >
                                <img
                                    src="/assets/icons/icon-close.svg"
                                    alt="Close"
                                    className="invert cursor-pointer"
                                />
                            </button>
                            <div className="p-5 py-8 w-full flex flex-col justify-center items-center min-h-[400px]">
                                {/* {getIcon()} */}
                                <div className="flex flex-col items-center mt-auto">
                                    {title && (
                                        <span className="text-[28px] text-primary">
                                            {title}
                                        </span>
                                    )}
                                    {message && (
                                        <span className="text-xs lg:text-sm text-white/60 max-w-[350px] text-center mt-2">
                                            {message}
                                        </span>
                                    )}
                                </div>
                                <button
                                    onClick={onButtonClick || onClose}
                                    to={buttonLink}
                                    className="text-center mt-auto w-full max-w-[90%] rounded-[10px] bg-white py-3 text-sm"
                                // buttonClassName="border-style-decoration"
                                >
                                    {buttonText}
                                </button>
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
}
